<template>
  <div class="div-componenteInformacionSinRegistros">
    <div class="div-sinRegistros">
      <f7-row>
        <f7-col class="col-iconoListaVacia">
          <img
            src="@/static/icons/ic_emptyList.svg"
            width="126"
            height="111"
          >
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col class="col-textoListaVacia">
          <span class="span-informacion">
            <span data-testid="pc-show-no-results-title">
              {{ title }}
            </span>
            <br>
            <span data-testid="pc-show-no-results-subtitle">
              {{ subtitle }}
            </span>
          </span>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script setup>
// @ts-check
defineProps({
  title: {
    type: String,
    default: 'Aún no hay registros',
  },
  subtitle: {
    type: String,
    default: 'Aún no hay registros',
  },
});
</script>

<style scoped lang="scss">
.div-sinRegistros {
  background: var(--his-tierra-white);
  min-height: -webkit-fill-available;
  height: 100vh;
}

.span-informacion {
  color: var(--his-ash-gray);
  font-size: 16px;
}

.col-iconoListaVacia {
  display: flex;
  justify-content: center;
  padding-top: 90px;
}

.col-textoListaVacia {
  text-align: center;
}
</style>
